import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getFeatured } from "@/lib/catalog";

export default function HeroCarousel() {
  const items = getFeatured();
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (items.length <= 1) return;
    const timer = setInterval(() => setIndex((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(timer);
  }, [items.length]);

  if (!items.length) return null;
  const active = items[index];

  return (
    <section className="relative w-full h-[480px] md:h-[600px] overflow-hidden bg-secondary-950">
      {items.map((m, i) => (
        <div
          key={m.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === index ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={m.hero ?? m.cover}
            alt={`${m.title}剧照`}
            title={`${m.title} - 高清电影推荐`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/90 via-secondary-950/60 to-secondary-950/20"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/80 via-transparent to-secondary-950/30"></div>

      <div className="relative z-10 h-full w-full px-4 md:px-8">
        <div className="h-full max-w-3xl flex flex-col justify-center">
          <span className="inline-flex items-center gap-2 self-start px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-label mb-5">
            <i className="ri-fire-line"></i>
            编辑精选 · 本周热推
          </span>
          <div key={active.id} className="animate-fade-up">
            <h1 className="font-heading font-black text-background-50 text-4xl md:text-6xl leading-tight mb-4">
              {active.title}
            </h1>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-background-200 text-sm mb-4">
              <span className="flex items-center gap-1 text-accent-300 font-label font-semibold">
                <i className="ri-star-fill"></i>
                {active.rating.toFixed(1)}
              </span>
              <span>{active.year}</span>
              <span>{active.region}</span>
              <span>{active.duration}</span>
              <span className="hidden sm:inline text-background-300">{active.genres.join(" / ")}</span>
            </div>
            <p className="text-background-200/90 text-sm md:text-base leading-7 max-w-2xl line-clamp-3 mb-7">
              {active.synopsis}
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${active.id}`}
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                查看详情
              </Link>
              <button
                type="button"
                onClick={() => navigate("/category")}
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm font-label hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
              >
                浏览分类
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="absolute z-10 bottom-6 left-4 md:left-8 right-4 md:right-8 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {items.map((m, i) => (
            <button
              key={m.id}
              type="button"
              onClick={() => setIndex(i)}
              aria-label={`切换到${m.title}`}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                i === index ? "w-8 bg-primary-400" : "w-4 bg-background-50/40 hover:bg-background-50/70"
              }`}
            ></button>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setIndex((i) => (i - 1 + items.length) % items.length)}
            aria-label="上一部"
            className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-background-50/10 border border-background-50/30 text-background-50 flex items-center justify-center hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            type="button"
            onClick={() => setIndex((i) => (i + 1) % items.length)}
            aria-label="下一部"
            className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-background-50/10 border border-background-50/30 text-background-50 flex items-center justify-center hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}